import axios from "axios";

//会以列表
export interface RecordingListItem {
    id: string;
    meetingId: string;
    name: string;
    fileKey: string;
}
export interface GetMeetingListItemData {
    meetingId: string;
    text: string;
    url: string;
    title: string;
    time: string;
    type: string;
    recording: RecordingListItem[];
}
export function getMeetingActivityList(params: { weekTimeId: number }) {
    return axios
        .get<SuccessData<GetMeetingListItemData[]>>(
            `/student/getMeetingActivityList`,
            { params }
        )
        .then(res => res.data.data);
}

//会议详情
export function getMeetingActivity(params: {
    meetingId: string;
    weekTimeId: number;
}) {
    return axios
        .get<SuccessData<GetMeetingListItemData>>(
            `/student/getMeetingActivity`,
            { params }
        )
        .then(res => res.data.data);
}
